(function() {
  const callback = () => {
    const pumperWrapper = document.querySelector('.pumper__quantity_label1');

    if(pumperWrapper) {
      const priceBlock = document.querySelector(".product__price");

      priceBlock?.classList.add('hidden');
    }
  }

  const priceObserver = new MutationObserver(callback);
  const target = document.querySelector('.product-single__form');

  priceObserver.observe(target, {childList: true, subtree: true});
})();
